
import { WorldCity } from '../types';

// Expansión de Hungría - 85 ciudades adicionales
export const hungaryAdditionalCities: WorldCity[] = [
  { name: 'Debrecen', slug: 'debrecen', population: 202214 },
  { name: 'Miskolc', slug: 'miskolc', population: 157177 },
  { name: 'Szeged', slug: 'szeged', population: 161921 },
  { name: 'Pécs', slug: 'pecs', population: 145347 },
  { name: 'Győr', slug: 'gyor', population: 131425 },
  { name: 'Nyíregyháza', slug: 'nyiregyhaza', population: 118185 },
  { name: 'Kecskemét', slug: 'kecskemet', population: 111863 },
  { name: 'Székesfehérvár', slug: 'szekesfehervar', population: 95818 },
  { name: 'Szombathely', slug: 'szombathely', population: 76773 },
  { name: 'Szolnok', slug: 'szolnok', population: 70285 },
  { name: 'Tatabánya', slug: 'tatabanya', population: 66902 },
  { name: 'Kaposvár', slug: 'kaposvar', population: 63431 },
  { name: 'Békéscsaba', slug: 'bekescsaba', population: 58251 },
  { name: 'Érd', slug: 'erd', population: 67642 },
  { name: 'Hódmezővásárhely', slug: 'hodmezovasarhely', population: 44019 },
  { name: 'Zalaegerszeg', slug: 'zalaegerszeg', population: 56302 },
  { name: 'Sopron', slug: 'sopron', population: 61791 },
  { name: 'Eger', slug: 'eger', population: 53020 },
  { name: 'Nagykanizsa', slug: 'nagykanizsa', population: 46598 },
  { name: 'Dunaújváros', slug: 'dunaujvaros', population: 46516 },
  { name: 'Salgótarján', slug: 'salgotarjan', population: 35246 },
  { name: 'Cegléd', slug: 'cegled', population: 35265 },
  { name: 'Veszprém', slug: 'veszprem', population: 57654 },
  { name: 'Baja', slug: 'baja', population: 36321 },
  { name: 'Gyula', slug: 'gyula', population: 31781 },
  { name: 'Orosháza', slug: 'oroshaza', population: 27776 },
  { name: 'Kazincbarcika', slug: 'kazincbarcika', population: 27209 },
  { name: 'Szigetszentmiklós', slug: 'szigetszentmiklos', population: 31196 },
  { name: 'Ajka', slug: 'ajka', population: 28418 },
  { name: 'Kiskunfélegyháza', slug: 'kiskunfelegyhaza', population: 29753 },
  { name: 'Mosonmagyaróvár', slug: 'mosonmagyarovar', population: 32313 },
  { name: 'Ózd', slug: 'ozd', population: 33129 },
  { name: 'Hatvan', slug: 'hatvan', population: 21010 },
  { name: 'Várpalota', slug: 'varpalota', population: 20618 },
  { name: 'Mátészalka', slug: 'mateszalka', population: 17111 },
  { name: 'Balassagyarmat', slug: 'balassagyarmat', population: 15341 },
  { name: 'Berettyóújfalu', slug: 'berettyoujfalu', population: 15531 },
  { name: 'Keszthely', slug: 'keszthely', population: 20895 },
  { name: 'Pápa', slug: 'papa', population: 32473 },
  { name: 'Jászberény', slug: 'jaszbereny', population: 26025 },
  { name: 'Komló', slug: 'komlo', population: 24014 },
  { name: 'Makó', slug: 'mako', population: 22544 },
  { name: 'Siófok', slug: 'siofok', population: 25388 },
  { name: 'Szentes', slug: 'szentes', population: 27368 },
  { name: 'Mohács', slug: 'mohacs', population: 18710 },
  { name: 'Kiskunhalas', slug: 'kiskunhalas', population: 27792 },
  { name: 'Gödöllő', slug: 'godollo', population: 34396 },
  { name: 'Mezőtúr', slug: 'mezotur', population: 16782 },
  { name: 'Monor', slug: 'monor', population: 18498 },
  { name: 'Dabas', slug: 'dabas', population: 16975 },
  { name: 'Hajdúszoboszló', slug: 'hajduszoboszlo', population: 23094 },
  { name: 'Hajdúböszörmény', slug: 'hajduboszormeny', population: 30852 },
  { name: 'Paks', slug: 'paks', population: 19251 },
  { name: 'Kiskunmajsa', slug: 'kiskunmajsa', population: 11099 },
  { name: 'Karcag', slug: 'karcag', population: 20011 },
  { name: 'Püspökladány', slug: 'puspokladany', population: 15000 },
  { name: 'Tiszaújváros', slug: 'tiszaujvaros', population: 16378 },
  { name: 'Hajdúnánás', slug: 'hajdunanas', population: 17498 },
  { name: 'Törökszentmiklós', slug: 'torokszentmiklos', population: 22045 },
  { name: 'Dombóvár', slug: 'dombovar', population: 18123 },
  { name: 'Gyöngyös', slug: 'gyongyos', population: 29169 },
  { name: 'Szentendre', slug: 'szentendre', population: 26263 },
  { name: 'Budakeszi', slug: 'budakeszi', population: 14751 },
  { name: 'Dunakeszi', slug: 'dunakeszi', population: 40290 },
  { name: 'Vecsés', slug: 'vecses', population: 20949 },
  { name: 'Fót', slug: 'fot', population: 18388 },
  { name: 'Gyál', slug: 'gyal', population: 23334 },
  { name: 'Pomáz', slug: 'pomaz', population: 17491 },
  { name: 'Budaörs', slug: 'budaors', population: 26758 },
  { name: 'Szigethalom', slug: 'szigethalom', population: 17890 },
  { name: 'Tahitótfalu', slug: 'tahitotfalu', population: 4511 },
  { name: 'Solymár', slug: 'solymar', population: 10085 },
  { name: 'Pilisvörösvár', slug: 'pilisvorosvar', population: 13551 },
  { name: 'Vác', slug: 'vac', population: 33265 },
  { name: 'Törökbálint', slug: 'torokbalint', population: 13411 },
  { name: 'Pécel', slug: 'pecel', population: 15679 },
  { name: 'Biatorbágy', slug: 'biatorbagyi', population: 12820 },
  { name: 'Nagykovácsi', slug: 'nagykovacsi', population: 7451 },
  { name: 'Érd', slug: 'erd-suburb', population: 67642 },
  { name: 'Százhalombatta', slug: 'szazhalombatta', population: 17154 },
  { name: 'Halásztelek', slug: 'halasztelek', population: 10955 },
  { name: 'Dunavarsány', slug: 'dunavarsany', population: 8445 },
  { name: 'Taksony', slug: 'taksony', population: 6027 },
  { name: 'Ráckeve', slug: 'rackeve', population: 10579 },
  { name: 'Délegyháza', slug: 'delegyhaza', population: 3842 },
  { name: 'Szigetcsép', slug: 'szigetcsep', population: 3201 }
];

export const hungaryExpanded = {
  code: 'HU',
  name: 'Hungary',
  slug: 'hungary',
  population: 9660351,
  topCities: [
    { name: 'Budapest', slug: 'budapest', population: 1752286 },
    ...hungaryAdditionalCities
  ]
};
